import styled from 'styled-components';

import { Color } from '../../../shared/constants/Colors';
import { Typography } from '../../../shared/constants/Typographies';

export const ButtonContainer = styled.div`
  height: 55px;
`;

export const Menu = styled.div`
  display: ${({ isHorizontal }) => (isHorizontal ? 'flex' : 'inline-grid')};
  flex-direction: column;
  text-align: ${({ isHorizontal }) => (isHorizontal ? '' : 'center')};
  position: relative;

  button {
    ${({ isHorizontal }) =>
      !isHorizontal &&
      `
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    `}

    ${({ isHorizontal }) =>
      isHorizontal &&
      `
    margin: 0 5px 0 0;
    `}
  }
`;

export const ButtonWrapper = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  max-width: 180px;
`;

export const Title = styled.span`
  ${Typography.S_BOLDER};
  color: ${Color.CLOUD_BURST};
  margin: 0;
  padding-bottom: 15px;
`;
